<template>
  <div>
    <multiselect
      v-model="referrals"
      panelName="encounter_referral"
      panelType="select"
      languagePath="locations"
      :sortAlphabetical=true
      :onClick="set"
      >
    </multiselect>
  </div>
</template>

<script>
  import multiselect from './MultiSelect.vue'
  import { mapActions, mapGetters } from 'vuex'

  function locationToResponse(loc) {
    return {
      id: loc.name,
      name: `encounter_referral.${loc.name}`,
      ordering: 0,
      selected: false,
      unknown: false,
      value: loc.name,
      token: loc.localization_key,
    }
  }

  export default {
    name: 'referral',
    components: { multiselect },
    data() {
      return {
        referrals: []
      }
    },
    methods: {
      initializePanelResponses() {
        const referralGroups = this.$store.state.settings.referrals || []
        const referralGroup = referralGroups.find(loc => loc.name === this.location.name)
        const referralResponses = referralGroup.referral_sites.map(locationToResponse)
        this.referrals = referralResponses
      },
      set() {
        // when a selection is made, update the panel response object in the store
        this.setPanelResponses(this.referrals)
      },
      ...mapActions({
        setPanelResponses: 'v4/panel/set',
      }),
    },
    computed: {
      ...mapGetters({
        location: 'v4/location/current',
        panel: 'v4/panel/current',
      }),
    },
    mounted() {
      if (this.panel.responses.some(i => i.selected)) {
        // panel has already been answered
        // set the view equal to the current panel responses
        this.referrals = this.panel.responses
      }
      else {
        // panel has not been answered
        // panel currently has a generic set of responses
        // initialize panel responses based on site selection
        this.initializePanelResponses()
      }
    },
  }
</script>
